module.exports = __webpack_public_path__ + "img/joystick-with-bg.8a9c15dd.png";